export default __webpack_public_path__ + "static/media/rainCoat.2d1241b2.svg";